// Shared activity-type display metadata (icon / label / color) for the
// client-activity surfaces. Promoted out of ActivitiesPage.tsx so the shared
// LogActivityModal (and future lead-timeline surfaces) reuse one source of
// truth rather than duplicating the icon/label map.
import React from 'react';
import {
  ClipboardList,
  FileText,
  Mail,
  MessageSquare,
  Phone,
  PhoneIncoming,
  Users,
  Video,
} from 'lucide-react';
import type { ActivityType } from '../../hooks/useActivities';

export const ACTIVITY_META: Record<
  ActivityType,
  { label: string; icon: React.ComponentType<{ className?: string }>; color: string }
> = {
  call_outbound: { label: 'Outbound Call', icon: Phone, color: 'text-blue-400' },
  call_inbound: { label: 'Inbound Call', icon: PhoneIncoming, color: 'text-blue-400' },
  meeting_in_person: { label: 'Meeting (in-person)', icon: Users, color: 'text-emerald-400' },
  meeting_video: { label: 'Meeting (video)', icon: Video, color: 'text-emerald-400' },
  email_sent: { label: 'Email', icon: Mail, color: 'text-amber-400' },
  sms_sent: { label: 'SMS', icon: MessageSquare, color: 'text-amber-400' },
  note: { label: 'Note', icon: FileText, color: 'text-gray-400' },
  document_sent: { label: 'Document Sent', icon: FileText, color: 'text-purple-400' },
  other: { label: 'Other', icon: ClipboardList, color: 'text-gray-400' },
};
